import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const Withdrawal = () => {
    return (
        <>
            <div className="breadcrumb">
                <h2>Withdrawal & Dismissal</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>Rules</li>
                    <li>|</li>
                    <li>Withdrawal & Dismissal</li>
                </ul>
            </div>
            <div className="inner_page uniform_section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <ul className="list-view">
                                <li>No School leaving certificate will be issued without a written application from the parents/guardian after the payment of all dues to the school.</li>
                                <li>Prior to the withdrawal of a student from the school a month's notice or payment of a month's fee is required.</li>
                                <li>As a rule students who are dismissed from the school will not be re-admitted.</li>
                                <li>Irregular attendance, habitual idleness, disobedience, bad conduct, involvement in sexual harassment, sexual misconduct with the opposite sex, or sickness liable to be injurious or contagious to other students, will justify the dismissal.</li>
                                <li>Students of those parents who regularly make complaints and are not satisfied with the facilities provided by the school management will be given notice to withdraw their wards; if not withdrawn T.C. will be issued along with their progress report of the final exam.</li>
                                <li>Readmission to this school will be banned for those who even if have passed or promoted academically, but have recived "Notice from information" fo in-disiplinary behaviour in the school, for more than 3 times with a final warning and have not shown any remarkable improvement, They will be issues the T.C along with their progress report.</li>
                                <li>The Principal's decision shall be final in all cases of dismissal or withdrawal.</li>
                                <li>A child who uses unfair means or recieves or gives assistance in any from for cheating durinbg examination & class-test will be given zero in the subject and repetition of the same fault will result in dismissal of the student from the school.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Withdrawal
